import {connect} from 'react-redux';
import {getStatus} from 'redux-resource';
import compose from 'recompose/compose';
import withHandlers from 'recompose/withHandlers';
import AdminUserItem from './item';

function mapStateToProps(state, props) {
	const {pending: isPending} = getStatus(state, `users.meta[${props.item.id}].updateStatus`);

	return {
		isPending
	};
}

const enhance = compose(
	connect(mapStateToProps),
	withHandlers({
		onPrivilegesChange: props => (event, value) => {
			props.onPrivilegesChange(props.item.id, value);
		},
		onConfirmationChange: props => (event, value) => {
			props.onConfirmationChange(props.item.id, value);
		},
		onDelete: props => () => {
			props.onDelete(props.item.id, props.item.email);
		}
	}),
);

export default enhance(AdminUserItem);



// WEBPACK FOOTER //
// ./src/client/components/admin/users/item/index.js